<div
  class="drs_logo_container d-flex justify-content-center align-items-center"
  [matTooltip]="'SHARED.DRS_TOOLTIP' | translate"
  [ngStyle]="{ width: containerWidth + 'px', height: containerHeight + 'px' }"
>
  <img
    class="drs_logo"
    src="assets/pics/drs.svg"
    alt="drs_logo"
    [ngStyle]="{ width: logoWidth + 'px' }"
  />
</div>
